function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWhiteboardHide = function SvgWhiteboardHide(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.736 3.14a.722.722 0 0 1 1.01 0L12.1 5.46l2.353-2.319a.722.722 0 0 1 1.01 0c.28.275.28.721 0 .996L13.11 6.455l2.353 2.318c.279.275.279.72 0 .996a.722.722 0 0 1-1.01 0L12.098 7.45 9.746 9.77a.722.722 0 0 1-1.01 0 .697.697 0 0 1 0-.996l2.353-2.318-2.353-2.319a.697.697 0 0 1 0-.996z",
    style: {
      strokeWidth: 0.945753
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.674 12.791h-4.617l2.412 5.347a.7.7 0 0 1-.363.93.719.719 0 0 1-.943-.358l-2.67-5.919H9.705l-2.67 5.919a.719.719 0 0 1-.943.357.7.7 0 0 1-.362-.929l2.411-5.347H3.524c-.79 0-1.429-.63-1.429-1.408V1.526c0-.778.64-1.408 1.43-1.408h17.15c.788 0 1.428.63 1.428 1.408v9.857c0 .778-.64 1.408-1.429 1.408zM3.524 1.526h17.15v9.857H3.525Z",
    style: {
      strokeWidth: 0.945753
    }
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "6.66667px",
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      InkscapeFontSpecification: "'sans-serif, Bold'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal"
    },
    x: 2.885,
    y: 24.043
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 2.885,
    y: 24.043,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "6.66667px",
      fontFamily: "sans-serif",
      InkscapeFontSpecification: "'sans-serif, Bold'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal"
    }
  }, "HIDE")));
};
export default SvgWhiteboardHide;